module.exports = __webpack_public_path__ + "static/media/gsb-iconBeauty&Health.0b2fafef.svg";